import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ResultRendererProps } from './types';

type Payload = {
  url?: string;
  domain?: string;
  subdomain?: string;
  path?: string;
  content_type?: string;
  image_b64?: string;
};

function getPayload(results: any[]): Payload | null {
  if (!Array.isArray(results) || results.length === 0) return null;
  const first = results[0];
  return first && typeof first === 'object' ? first : null;
}

const ScreenshotResults: React.FC<ResultRendererProps> = ({ results }) => {
  const { t } = useTranslation();
  const data = getPayload(results);

  if (!data?.image_b64) {
    return <p className="text-sm text-slate-500">{t('tools.results_scan.screenshot.empty')}</p>;
  }

  const url = data.url || '';
  const ct  = data.content_type || 'image/png';
  const dataUrl = `data:${ct};base64,${data.image_b64}`;

  return (
    <div className="w-full space-y-4">
      {/* encabezado */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="text-sm text-slate-700 truncate">
          <span className="font-semibold text-slate-900">{t('tools.results_scan.screenshot.page')}</span>
          <span className="mx-1 text-slate-400">•</span>
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-sky-700 hover:underline">
            {url}
          </a>
        </div>
        <a
          className="inline-flex items-center rounded px-3 py-1.5 text-xs font-semibold ring-1 ring-slate-300 hover:bg-slate-50"
          href={dataUrl}
          download="screenshot.png"
        >
          {t('tools.results_scan.screenshot.download')}
        </a>
      </div>

      {/* imagen responsive */}
      <div className="w-full overflow-auto rounded-lg border border-slate-200 bg-white p-2">
        <img
          src={dataUrl}
          alt={url ? `Screenshot of ${url}` : 'Screenshot'}
          className="max-w-full h-auto mx-auto rounded"
        />
      </div>
    </div>
  );
};

export default ScreenshotResults;
